export const HEMOGLOBIN = 'hemoglobin';
export const KREATININ = 'kreatinin';
export const TOTAL_CHOLESTEROL = 'totalcholesterol';
export const LDL_CHOLESTEROL = 'ldlcholesterol';
export const HDL_CHOLESTEROL = 'hdlcholesterol';
export const CRP = 'crp';
export const LEUKOZYTEN = 'leukozyten';
export const MCV = 'mcv';
export const RDW = 'rdw';
export const THROMBOZYTEN = 'thrombozyten';
export const GFR = 'gfr';
export const CD4_CELL_COUNT = 'cd4CellCount';
export const CD4_PERCENT = 'cd4Percent';
export const CD4CD8_RATIO = 'cd4cd8Ratio';
export const HIV_RNA = 'hivRna';
export const CD4_NADIR = 'cd4Nadir';

export const LaboratoryKeys = [
    HEMOGLOBIN,
    KREATININ,
    TOTAL_CHOLESTEROL,
    LDL_CHOLESTEROL,
    HDL_CHOLESTEROL,
    CRP,
    LEUKOZYTEN,
    MCV,
    RDW,
    THROMBOZYTEN,
    GFR,
    CD4_CELL_COUNT,
    CD4_PERCENT,
    CD4CD8_RATIO,
    HIV_RNA,
    CD4_NADIR
];

/**
 * Leukozyten < 4.0
 * Hämoglobin <  		ATTENTION: <12 for women and <13 for men!!
 * MCV < 82
 * RDW-CV < 11,6
 * Thrombozyten < 150
 */
export const CCUSThresholds = {
    [LEUKOZYTEN]: 4.0,
    [HEMOGLOBIN]: 13,
    [HEMOGLOBIN+'_'+'MALE']: 13,
    [HEMOGLOBIN+'_'+'FEMALE']: 12,
    [MCV]: 82,
    [RDW]: 11.6,
    [THROMBOZYTEN]: 150
}
